/* eslint-disable arrow-body-style */
import { Box, Divider, Flex } from '@chakra-ui/react';
import { Avatar, AvatarFallback, AvatarImage } from '@mesh.ai/rabbit';
import { getFallbackName } from 'Deer/helpers/utils';

import { ArrowBack } from 'assets/assetsV1/iconComponents';

import { DrawerFooter, primaryDrawerWidth } from 'uiToolkitV1/BottomDrawer';
import { BUTTON_VARIANT, Button } from 'uiToolkitV1/Button';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { useSelectAddViolationDrawerData } from '../slice/addViolation.slice';

const PastNotesPanel = ({ onBack }: { onBack?: () => void }) => {
  const { pastNotes, raisedFor } = useSelectAddViolationDrawerData();

  const getFormattedDateAndTime = (reportedDateTime) => {
    if (Number.isNaN(new Date(reportedDateTime).getTime())) {
      return 'N.A';
    }
    const reportedTime = reportedDateTime ? new Date(reportedDateTime) : new Date();
    const date = reportedTime.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    const time = reportedTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
    return `${date} • ${time}`;
  };

  const formattedPastNotes = pastNotes.map((note) => {
    return {
      type: note.TYPE,
      description: note.DESCRIPTION,
      id: note.NOTE_ID,
      raisedFor: note.RAISED_FOR,
      raisedBy: note.RAISED_BY,
      reportedTime: getFormattedDateAndTime(note.REPORTED_TIME),
      location: note.LOCATION,
      status: note.STATUS,
    };
  });

  return (
    <Flex w={primaryDrawerWidth} flexDir="column" border="4px solid #EBEFF3" borderRadius="8px" h="100%">
      <Box p="12px">
        <TextBodyMedium bold>Past notes for {raisedFor?.displayName}</TextBodyMedium>
        <Divider mt="12px" />
      </Box>
      <Box overflowY="auto" h="100%">
        {formattedPastNotes.map((note) => (
          <Box p="12px">
            <Box id="violation-header" paddingBottom="8px">
              <TextBodyMedium bold>{note.type}</TextBodyMedium>
            </Box>
            <Box id="date" py="8px" color="#666666">
              {note.reportedTime}
            </Box>
            <Box id="user-info">
              <Flex flexDir="column">
                <Flex gap="8px" alignItems="center">
                  <Avatar>
                    <AvatarFallback>{getFallbackName(note.raisedFor?.displayName)}</AvatarFallback>
                    <AvatarImage src={note.raisedFor?.profilePhoto} />
                  </Avatar>
                  <TextBodyMedium>{note.raisedFor?.displayName}</TextBodyMedium>
                </Flex>
              </Flex>
            </Box>
            <Box id="violation-description" py="8px">
              {note.description}
            </Box>
            <Divider mt="8px" />
          </Box>
        ))}
      </Box>

      <DrawerFooter h="72px" backgroundColor="neutral.F5F7F9" mt="auto">
        <Flex bgColor="neutral.F5F7F9" justifyContent="center" w="100%">
          <Button variant={BUTTON_VARIANT.tertiary} onClick={onBack} StartIcon={ArrowBack}>
            Back
          </Button>
        </Flex>
      </DrawerFooter>
    </Flex>
  );
};

export { PastNotesPanel };
